import { render, staticRenderFns } from "./MonitoringLogsTab.vue?vue&type=template&id=04fe503c&lang=pug&"
import script from "./MonitoringLogsTab.vue?vue&type=script&lang=js&"
export * from "./MonitoringLogsTab.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringLogsTab.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports